import { render, staticRenderFns } from "./FactoryComponent.vue?vue&type=template&id=4a29cd80&"
import script from "./FactoryComponent.vue?vue&type=script&lang=js&"
export * from "./FactoryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports